module.exports = __webpack_public_path__ + "public/images/logo_pt.449929228ca4c42954c8936424d78717.png";